export const blockIconsAudioandvideoVolumeUpNew = (
	<span className='material-symbols-outlined'>volume_up</span>
);
